export default __webpack_public_path__ + "static/media/cdimg1.c43ba8d2.PNG";